import React from "react";
import { withRouter } from "react-router";
import { Button } from "antd";

const styles = {
  fullWidthStyle: {
    width: "100%",
    padding: 64,
    textAlign: "center"
  }
};

const NotFound = props => {
  return (
    <div style={styles.fullWidthStyle}>
      <h2>{"Page Not Found"}</h2>
      <Button type="primary" onClick={() => props.router.push("/")}>
        {"Back to Home Page"}
      </Button>
    </div>
  );
};

export default withRouter(NotFound);
